// import 'svgxuse'; // Uncomment to support svg icons on IE

import { createPopper } from '@popperjs/core';
import * as bootstrap from 'bootstrap';
//import ClipboardJS from 'clipboard';
import './components/header'
import './components/observer'
import './components/offcanvas'
import './components/numbers'
import './components/article'
import './components/panel'
import './components/modal'
import './components/video'
import './components/carousel'
//import './components/countdown'
import './components/smooth-scroll'
import './components/menu'
import './components/team-filters'
import './components/stock-price'

// BS Tooltip init
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
